import { createFileRoute } from '@tanstack/react-router';

import { TemplatesPage } from '@/features/templates/templates-page';

export const Route = createFileRoute('/_app/org/$orgId/templates')({ component: OrgRoute });

function OrgRoute() {
  const { orgId } = Route.useParams();
  return <TemplatesPage orgId={orgId} />;
}
